import DataTablesBase from '../datatables.js';

var Tips = new DataTablesBase();

export default Tips;